import PropTypes from 'prop-types';

import { theme } from '@prose-ui';
import { legacyTheme, styled } from '@prose-ui/legacy';

import { Typography } from 'Components/Typography';

import { productsLabels } from 'constants/products';

import { srcOrNextImageProp } from 'PropTypes/imageProps';

const Card = styled.section`
  text-align: center;
  margin-bottom: 40px;
  display: flex;
  flex-flow: column;
  align-items: center;
  min-width: 125px;
  max-width: 125px;
  margin: ${legacyTheme.spacing.s24} ${legacyTheme.spacing.s8} 0;

  ${legacyTheme.breakpoints.up('sm')} {
    min-width: 184px;
    max-width: 184px;
    margin: ${legacyTheme.spacing.s32} ${legacyTheme.spacing.s8} 0;
  }

  ${legacyTheme.breakpoints.up('md')} {
    min-width: 195px;
    max-width: 195px;
    margin: ${legacyTheme.spacing.s80} 30px 0;
  }
`;

const Image = styled.img`
  max-width: 100%;
`;

const Name = styled(Typography)`
  min-height: 63px;
  ${legacyTheme.breakpoints.up('sm')} {
    min-height: 42px;
  }
`;

const Description = styled(Typography)`
  min-height: 90px;
  ${legacyTheme.breakpoints.up('sm')} {
    min-height: 60px;
  }
`;

const Spacer = styled.div`
  height: 1px;
  width: 50px;
  background-color: ${theme.colors.neutral['700']};
  margin: ${legacyTheme.spacing.s16} 0px;
`;

const BoldText = styled(Typography)`
  min-height: 33px;
  font-weight: 600;
  ${legacyTheme.breakpoints.up('sm')} {
    min-height: 0px;
  }
`;

const NoWrapText = styled(BoldText)`
  white-space: nowrap;
`;

const IngredientCard = ({ className, description, image, name, usage, includedIn }) => (
  <Card className={className}>
    <div>
      <Image alt={name} src={image.src} />
    </div>
    <Name color="noir" paragraph variant="p2">
      {name}
    </Name>
    <BoldText color="grey" paragraph variant="mono3">
      {usage}
    </BoldText>
    {description && (
      <Description color="grey" variant="p3">
        {description}
      </Description>
    )}
    {Boolean(includedIn?.length) && (
      <>
        <Spacer />
        <NoWrapText color="grey" variant="mono3">
          INCLUDED IN YOUR:
        </NoWrapText>
        <Description color="grey" variant="p3">
          {includedIn?.map(included => productsLabels[included])?.join(', ')}
        </Description>
      </>
    )}
  </Card>
);

IngredientCard.propTypes = {
  className: PropTypes.string,
  description: PropTypes.string,
  image: srcOrNextImageProp.isRequired,
  includedIn: PropTypes.arrayOf(PropTypes.string),
  name: PropTypes.string.isRequired,
  usage: PropTypes.string.isRequired,
};

IngredientCard.defaultProps = {
  className: null,
  description: '',
  includedIn: null,
};

export default IngredientCard;
